[
  {
    "id": 2,
    "topText": "TAP INTO THE",
    "title": "BUSINESS TRAVELERS",
    "stepLabel": "Business Traveler",
    "videoAsset": "BusinessTraveler.mp4",
    "points": [
      "Frequent weekday corporate bookings",
      "Use business credit cards for stays",
      "High room-night frequency"
    ]
  },
  {
    "id": 3,
    "topText": "TAP INTO THE",
    "title": "FAMILY TRAVELERS",
    "stepLabel": "Family Traveler",
    "videoAsset": "FamilyTraveler.mp4",
    "points": [
      "Parents with kids under 18",
      "Seek family-friendly amenities",
      "Child-focused activities drive decisions"
    ]
  },
  {
    "id": 4,
    "topText": "TAP INTO THE",
    "title": "SUN-SEEKING TRAVELER",
    "stepLabel": "Sun-Seeking Traveler",
    "videoAsset": "LeisureTraveler.mp4",
    "points": [
      "Passion for outdoor sports (ski, golf, cycling)",
      "Seasonal travel patterns for nature activities",
      "Strong interest in gear and adventure destinations"
    ]
  },
  {
    "id": 5,
    "topText": "TAP INTO THE",
    "title": "WELLNESS TRAVELER",
    "stepLabel": "Wellness Traveler",
    "imageAsset": "wellnessTraveler.png",
    "points": [
      "Has focus on spa, fitness, yoga",
      "Prefers curated lifestyle experiences",
      "Engages with luxury and premium brands"
    ]
  },
  {
    "id": 6,
    "topText": "TAP INTO THE",
    "title": "LUXURY TRAVELERS",
    "stepLabel": "Luxury Traveler",
    "videoAsset": "LuxuryTraveler.mp4",
    "points": [
      "High-value guests with consistent luxury spend",
      "Prefer premium rooms, spa, and golf experiences",
      "Strong loyalty to upscale brands"
    ]
  },
  {
    "id": 7,
    "topText": "TAP INTO THE",
    "title": "GLOBAL TRAVELERS",
    "stepLabel": "Global Traveler",
    "videoAsset": "InternationalTraveler.mp4",
    "points": [
      "Globally mobile, passport-ready guests",
      "At least one international stay in past 2 years",
      "High-value, frequent long-haul travelers"
    ]
  }
]
